import { render, staticRenderFns } from "./CompositionsStats.vue?vue&type=template&id=1fa64255&scoped=true&"
import script from "./CompositionsStats.vue?vue&type=script&lang=js&"
export * from "./CompositionsStats.vue?vue&type=script&lang=js&"
import style0 from "./CompositionsStats.vue?vue&type=style&index=0&id=1fa64255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa64255",
  null
  
)

export default component.exports